export default "__VITE_ASSET__DnxM0J5H__"